window.addEventListener('DOMContentLoaded', () => {
    const __triggers__ = document.querySelectorAll(".accordion__trigger");

    __triggers__.forEach(__trigger__ => {
        const __teamContent__ = __trigger__.parentNode.querySelector('collapsible-content');

        __trigger__.addEventListener('click', () => {
            __teamContent__.open = !__teamContent__.open;
            __trigger__.classList.toggle("open");

            __trigger__.ariaExpanded = __trigger__.ariaExpanded !== "true" ? "true" : "false";
        })
    })

    document.addEventListener('variant:changed', function(event) {
        const variantDescriptions = document.querySelectorAll('.variant--description');
        const variant = event.detail.variant;

        variantDescriptions.forEach(__desc__ => {
            __desc__.classList.remove('selected');

            if (__desc__.dataset.variantId === variant.id.toString())
                __desc__.classList.add('selected');
        })
    });
});
